import * as $ from 'jquery';
import {hideContactInfo} from '../FlyOut/ContactAndSocialShareFlyOutController';
import {closeResponsiveMenu} from './MobileNavUtility';
import {SearchSuggest} from '../SearchSuggest/SearchSuggest';

const bodyNoScrollClass = 'body--noscroll';
const searchOpenClass = 'header--searchOpen';
let oldWindowWidth = window.innerWidth;
let searchSuggest;

export function addOpenBigSearchField() {
  oldWindowWidth = window.innerWidth;
  const $searchResultPageInput = $('.js-search-result-input');
  let searchValue = '';

  if ($searchResultPageInput.length) {
    searchValue = <string> $searchResultPageInput.val();
  }

  searchSuggest = new SearchSuggest(searchValue);
  searchSuggest.initSuggestFlyout();
  initEventListeners();
}

export function closeSearchOverlay() {
  $('body').removeClass(bodyNoScrollClass);
  $('#header').removeClass(searchOpenClass);
}

function initEventListeners() {
  const $body = $('body');
  $('.js-openSearchOverlay').on('click', () => {
    searchSuggest.openSuggestFlyout();
    oldWindowWidth = window.innerWidth;
    $('#header').addClass(searchOpenClass);
    $body.addClass(bodyNoScrollClass);
    hideContactInfo();
    closeResponsiveMenu();
    $('.js-searchInput').focus();
  });

  $('.js-closeSearchOverlay').on('click', (e) => {
    e.preventDefault();
    searchSuggest.closeSuggestFlyout();
    closeSearchOverlay();
  });

  $('.js-clearSearchInput').on('click', () => {
    searchSuggest.clearInput();
    searchSuggest.removeSuggestFlyoutContent();
    searchSuggest.closeSuggestFlyout();
  });

  $(window).on('resize', () => {
    let currentWindowWidth = window.innerWidth;

    // fire resize only on fast resize
    if (Math.abs(currentWindowWidth - oldWindowWidth) >= 50) {
      $body.addClass(bodyNoScrollClass);
      searchSuggest.closeSuggestFlyout();
      closeSearchOverlay();
    }
    oldWindowWidth = currentWindowWidth;
  });
}
